export default __webpack_public_path__ + "static/media/maisons_laffitte11.39ec590b.jpg";